module.exports = __webpack_public_path__ + "img/italy-icon.4f5dd918.png";